var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeneficioLeizure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.138,
    height: 121.961,
    viewBox: "0 0 248.138 121.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.506)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.361 53.251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 9.724,
    transform: "translate(0 0) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.591 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.724,
    transform: "translate(9.724 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.425 35.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 9.724,
    transform: "translate(0 0) rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.591 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.724,
    transform: "translate(9.724 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.177)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.009,
    cy: 23.009,
    rx: 23.009,
    ry: 23.009,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.009,
    cy: 23.009,
    rx: 21.509,
    ry: 21.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.564 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.967,364.835a3.271,3.271,0,0,0,4.5-.977l.067-.142.042-.025c15.025-13.339,36-6.244,36.211-6.169l.133.033a3.17,3.17,0,0,0,4.124-.927c.067-.092,7.412-9.749,24.14-5.376a3.047,3.047,0,0,0,.944.092,3.216,3.216,0,0,0,2.128-.042,3.267,3.267,0,0,0,1.92-4.2c-7.98-21.394-32.83-33.472-59.1-28.706l-.141.033h-.017c-.334.067-.668.133-.993.2a3.453,3.453,0,0,0-.735.15c-25.284,5.367-43.4,24.984-43.339,47.27a3.272,3.272,0,0,0,3.264,3.255h.008a3.225,3.225,0,0,0,2.4-1.085C568.4,358.466,578.492,364.534,578.967,364.835Zm4.257-9.107c-.792-19.766,7.863-27.829,11.386-30.284,4.174,1.06,15.126,5.576,21.327,24.407C608.4,348.466,595.061,347.714,583.224,355.728Zm61.119-11.861c-10.693-1.353-17.838,2.237-21.795,5.25-4.14-13.389-10.559-20.918-16.327-25.134C622.457,324.309,637.106,331.855,644.343,343.866Zm-61.377-15.292c-3.765,5.926-6.929,14.992-6.2,28.422-4.741-1.227-12.07-1.67-20.76,2.729C558.525,346.529,568.809,334.776,582.966,328.574Z",
    transform: "translate(-548.851 -305.783)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.489,324.3l6.427-1.16-.818-4.482a3.262,3.262,0,1,0-6.419,1.169Z",
    transform: "translate(-513.779 -315.977)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.448,329.09H555.8l1.627,8.731a3.26,3.26,0,0,0,3.205,2.671,3.643,3.643,0,0,0,.6-.05,3.272,3.272,0,0,0,2.613-3.815Z",
    transform: "translate(-497.766 -219.637)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.634,323.84l6.586,35.4h6.636l-6.8-36.586A28.892,28.892,0,0,0,554.634,323.84Z",
    transform: "translate(-506.362 -266.917)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.467,327.655a3.266,3.266,0,1,0-5.876-2.855l-10.576,21.828H610.736a3.264,3.264,0,1,0,0,6.528h8.356l-5.459,9.124H554.058a3.264,3.264,0,1,0,0,6.527H566.4l-7.1,11.853a3.265,3.265,0,0,0,1.127,4.482,3.22,3.22,0,0,0,1.67.467,3.267,3.267,0,0,0,2.8-1.586l9.115-15.217h64.516l9.115,15.217a3.267,3.267,0,0,0,5.6-3.364l-8.039-13.405a2.531,2.531,0,0,0,.2-.284Zm-37.763,25.5h18.138l-4.256,8.8a3.42,3.42,0,0,1-.527.326H621.245Z",
    transform: "translate(-534.576 -264.655)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficioLeizure);
export default __webpack_public_path__ + "static/media/beneficio-leizure.129fd5046b95626121cad5ffb0039bbb.svg";
export { ForwardRef as ReactComponent };